export default __webpack_public_path__ + "static/media/water.f8b34494.svg";